import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Step, StepLabel, Stepper, useTheme, StepConnector, Typography, Breadcrumbs, TableContainer, Table, TableHead, TableBody, FormControl, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { makeStyles } from 'tss-react/mui';
import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/material/styles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ErrorHandler from '../../lib/errorHandler';
import CommonAutoComplete from '../../Component/Common/CommonAutoComplete';
import { getVendors } from '../../Redux/Actions/Vendor';
import CommonTextField from '../../Component/Common/CommonTextField';
import CommonDatePicker from '../../Component/Common/CommonDatePicker';
import { InventoryTypeInum } from '../../lib/enum';
import { getAllItemName, getAllItemsByCategory, getInventoryFields } from '../../Redux/Actions/Inventory';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import IconBackground from '../../Component/Common/IconBackground';
import NoDataFound from '../../Component/Common/NoDataFound';
import Assets from '../../Component/Common/Assets';
import { categoryNameOptions, currencyOptions, monthsOption, useCommonStyles } from '../../utils';
import { addPurchaseOrder, downloadPO, updatePurchaseOrder } from '../../Redux/Actions/PurchaseOrder';
import ErrorMessage from '../../Component/Common/ErrorMessage';
import dayjs from 'dayjs';
import { useConfirm } from 'material-ui-confirm';
import downloadFileFromBlob from '../../lib/downloadFileFromBlob';
import CommonTextEditor from '../../Component/Common/CommonTextEditor';
import CommonRadioButton from '../../Component/Common/CommonRadioButton';
import { isCompleteDate } from '../../lib/standardDateFormat';

const useStyles = makeStyles()((theme) => ({
    stepper_main: {
        margin: "30px",
        "& .Mui-completed.Mui-completed": {
            color: "#1ABC86",
            fontFamily: "Satoshi-Bold",
        },
        "& .MuiStepLabel-label": {
            fontFamily: "Satoshi-Light",
            color: "#555151",
            fontSize: "16px",
        },
        "& .MuiStepLabel-label.Mui-active": {
            fontFamily: "Satoshi-Bold",
            fontSize: "16px",
            color: theme.palette.primary.main,
        },
        "& .MuiStepLabel-label.Mui-completed": {
            fontFamily: "Satoshi-Bold",
            fontSize: "16px",
            color: "#1ABC86",
        },
        "& .MuiStepConnector-root": {
            marginLeft: "18px"
        }
    }
}));

const CustomStepIcon = styled('div')(({ theme, active, completed }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
    border: active ? `1px solid ${theme.palette.primary.main}` : "1px solid transparent",
    backgroundColor: completed ? '#1ABC86' : theme.palette.bgWhite.main,
    color: completed ? '#FFF' : active ? theme.palette.primary.main : '#555151b3',
}));

const StepIcon = (props) => {
    const { active, completed, icon } = props;
    return (
        <CustomStepIcon active={active} completed={completed}>
            {completed ? <CheckIcon style={{ fontSize: '20px', color: '#FFF' }} /> : icon}
        </CustomStepIcon>
    );
};

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
    '& .MuiStepConnector-line': {
        borderColor: "#0000001A",
        borderWidth: 1,
        minHeight: "26px"
    },
    '&.Mui-completed .MuiStepConnector-line, &.Mui-active .MuiStepConnector-line': {
        borderColor: '#1ABC86',
    },
}))

// const coatingPreferencesOptions = [
//     { label: "Uncoated", value: "Uncoated" },
//     { label: "coated", value: "coated" },
// ];
const coatingPreferencesOptions = [
    { label: "Release Polyster Film", value: "Release Polyster Film" },
    { label: "Polyster Film", value: "Polyster Film" },
];
const portOptions = [
    { label: "Hajira Port", value: "Hajira" },
    { label: "Nhava Sheva Port", value: "NhavaShevaPort" },
    { label: "Mundra Port", value: "MundraPort" },
];
const portAnotherOptions = [
    { label: "CIF", value: "CIF" },
    { label: "FBO ", value: "FBO " },
];

const AddUpdatePo = ({ poResponse, setPoResponse, setBase64, base64, setIsOpenAddUpdatePO, setData, data, tableOptions, setTableOptions, purchaseOrderListData, setPurchaseOrderListData, selectedItem, setSelectedItem, _getPurchaseOrders, setSearchValue }) => {

    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();
    // const generateYearOptions = () => {
    //     const currentYear = new Date().getFullYear();
    //     const startYear = currentYear - 1;
    //     return Array.from({ length: 26 }, (_, i) => ({
    //         name: `${startYear + i}-${(startYear + i + 1).toString().slice(-2)}`
    //     }));
    // };


    // ============== States ==============
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([
        { name: "Basic Details" },
        { name: "Category Base PO" },
        { name: "Preview" },
    ]);
    const [POTypeOptions, setPOTypeOptions] = useState([])


    const [isAppliedFilter, setIsAppliedFilter] = useState(false);
    const [yearOptions, setYearOptions] = useState();
    const [yearOptionsForProduction, setYearOptionsForProduction] = useState();
    const [errors, setErrors] = useState({});

    const [vendorPage, setVendorPage] = useState(1);
    const [vendorTotalCount, setVendorTotalCount] = useState();
    const [vendorList, setVendorList] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);
    const [searchVendor, setSearchVendor] = useState();

    const [groupPage, setGroupPage] = useState(1);
    const [grouptotalCount, setGroupTotalCount] = useState();
    const [groupList, setGroupList] = useState([]);
    const [groupOptions, setGroupOptions] = useState([])
    const [searchGroup, setSearchGroup] = useState();

    const [subGroupPage, setSubGroupPage] = useState(1);
    const [subGrouptotalCount, setSubGroupTotalCount] = useState();
    const [subGroupList, setSubGroupList] = useState([]);
    const [subGroupOptions, setSubGroupOptions] = useState([])
    const [searchSubGroup, setSearchSubGroup] = useState();

    const [typeOfpaperPage, setTypeOfpaperPage] = useState(1);
    const [typeOfpapertotalCount, setTypeOfpaperTotalCount] = useState();
    const [typeOfpaperList, setTypeOfpaperList] = useState([]);
    const [typeOfpaperOptions, setTypeOfpaperOptions] = useState([]);
    const [searchTypeOfpaper, setSearchTypeOfpaper] = useState();

    const [colorPage, setColorPage] = useState(1);
    const [colorTotalCount, setColorTotalCount] = useState();
    const [colorList, setColorList] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [searchColor, setSearchColor] = useState();

    const [sizePage, setSizePage] = useState(1);
    const [sizeTotalCount, setSizeTotalCount] = useState();
    const [sizeList, setSizeList] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [searchSize, setSearchSize] = useState();

    const [micronPage, setMicronPage] = useState(1);
    const [micronTotalCount, setMicronTotalCount] = useState();
    const [micronList, setMicronList] = useState([]);
    const [micronOptions, setMicronOptions] = useState([]);
    const [searchMicron, setSearchMicron] = useState();

    const [chemicalPage, setChemicalPage] = useState(1);
    const [chemicalTotalCount, setChemicalTotalCount] = useState();
    const [chemicalList, setChemicalList] = useState([]);
    const [chemicalOptions, setChemicalOptions] = useState([]);
    const [searchChemical, setSearchChemical] = useState();

    const [chemicalCategoryPage, setChemicalCategoryPage] = useState(1);
    const [chemicalCategoryTotalCount, setChemicalCategoryTotalCount] = useState();
    const [chemicalCategoryList, setChemicalCategoryList] = useState([]);
    const [chemicalCategoryOptions, setChemicalCategoryOptions] = useState([]);
    const [searchChemicalCategory, setSearchChemicalCategory] = useState();

    // const [chemicalCodePage, setChemicalCodePage] = useState(1);
    // const [chemicalCodeTotalCount, setChemicalCodeTotalCount] = useState();
    // const [chemicalCodeList, setChemicalCodeList] = useState([]);
    // const [chemicalCodeOptions, setChemicalCodeOptions] = useState([]);
    // const [searchChemicalCode, setSearchChemicalCode] = useState();

    const [pantoneNumberPage, setPantoneNumberPage] = useState(1);
    const [pantoneNumberTotalCount, setPantoneNumberTotalCount] = useState();
    const [pantoneNumberList, setPantoneNumberList] = useState([]);
    const [pantoneNumberOptions, setPantoneNumberOptions] = useState([]);
    const [searchPantoneNumber, setSearchPantoneNumber] = useState();

    const [inkNamePage, setInkNamePage] = useState(1);
    const [inkNameTotalCount, setInkNameTotalCount] = useState();
    const [inkNameList, setInkNameList] = useState([]);
    const [inkNameOptions, setInkNameOptions] = useState([]);
    const [searchInkName, setSearchInkName] = useState();

    const [packagingPage, setPackagingPage] = useState(1);
    const [packagingTotalCount, setPackagingTotalCount] = useState();
    const [packagingList, setPackagingList] = useState([]);
    const [packagingOptions, setPackagingOptions] = useState([]);
    const [searchPackaging, setSearchPackaging] = useState();

    const [otherNamePage, setOtherNamePage] = useState(1);
    const [otherNameTotalCount, setOtherNameTotalCount] = useState();
    const [otherNameList, setOtherNameList] = useState([]);
    const [otherNameOptions, setOtherNameOptions] = useState([]);
    const [searchOtherName, setSearchOtherName] = useState();

    const [allItemsPage, setAllItemsPage] = useState(1);
    const [allItemsTotalCount, setAllItemsTotalCount] = useState();
    const [allItemsList, setAllItemsList] = useState([]);
    const [allItemsOptions, setAllItemsOptions] = useState([]);
    const [searchAllItems, setSearchAllItems] = useState("");

    const [unitPage, setUnitPage] = useState(1);
    const [unitTotalCount, setUnitTotalCount] = useState();
    const [unitList, setUnitList] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [searchUnit, setSearchUnit] = useState();


    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdatePO(false); setData({}); setSelectedItem({}); setPurchaseOrderListData([]); setBase64(''); setPoResponse({}); setSearchValue("") }}>
            Purchase order (PO)
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`${selectedItem?._id ? "Edit" : "Create New"} PO`}
        </Typography>,
    ];

    console.log("purchaseOrderListData", purchaseOrderListData);

    // ============== Handler ==============
    const handleCheckboxChange = (event) => {
        const value = Number(event.target.value); // Convert to number
        const checked = event.target.checked;

        setData((prevData) => {
            const currentTerms = Array.isArray(prevData.selectedCondition) ? prevData.selectedCondition : [];

            const updatedTerms = checked
                ? [...currentTerms, value]
                : currentTerms.filter((term) => term !== value);

            return { ...prevData, selectedCondition: updatedTerms };
        });
    };

    const updateOtherValue = (newvalue) => {
        setIsAppliedFilter(false)
        setData({
            ...data,
            category: newvalue,
            group: null,
            subGroup: null,
            typeOfpaper: null,
            size: null,
            micron: null,
            chemicalName: null,
            chemicalCode: null,
            chemicalCategory: null,
            inkName: null,
            pantoneNumber: null,
            packagingName: null,
            otherName: null,
            coatingPreferences: null,
            color: null,
            core: null,
            runningMeter: null
        })
        if (newvalue?.name == "Base Paper" || newvalue?.name == "Film" || newvalue?.name == "Chemical" || newvalue?.name == "Ink") {
            // setTableOptions({
            //     ...tableOptions,
            //     unit: { unit: "KG" }
            // })
            setTableOptions({
                ...tableOptions,
                unit: null
            })
        } else {
            setTableOptions({
                ...tableOptions,
                unit: null
            })
        }
        setPurchaseOrderListData([])
        setAllItemsPage(1)
        setAllItemsList([])
    }

    console.log("selectedItem", selectedItem);

    const resetFilter = () => {
        setIsAppliedFilter(true);
        setData({
            ...data,
            group: null,
            subGroup: null,
            typeOfpaper: null,
            size: null,
            micron: null,
            chemicalName: null,
            chemicalCode: null,
            chemicalCategory: null,
            inkName: null,
            pantoneNumber: null,
            packagingName: null,
            otherName: null,
            coatingPreferences: null,
            color: null,
            core: null,
            runningMeter: null
        })
    }
    const handleChangeForItems = (row, value, name) => {
        const updatedItems = purchaseOrderListData?.map((ele) => {
            if (ele?.itemName === row?.itemName) {
                let formattedValue = value;

                // Don't parse for secondaryName or unit (unit is an object)
                if (name !== "secondaryName" && name !== "unit") {
                    const num = parseFloat(value);
                    formattedValue = Number.isInteger(num)
                        ? num
                        : parseFloat(num.toFixed(3));
                }

                // Handle per-row unit selection
                if (name === "unit") {
                    let inton = ele?.inton || "";
                    // If unit is KG and category is Film or Base Paper, calculate inton
                    if (value?.unit?.toLowerCase() === "kg" && (data?.category?.name === "Film" || data?.category?.name === "Base Paper")) {
                        inton = ele?.quantity / 1000;
                    } else {
                        inton = "";
                    }
                    return {
                        ...ele,
                        unit: value?.unit || null,
                        inton: inton,
                    };
                }

                // Handle quantity changes - recalculate inton based on row's unit
                if (name === "quantity" && ele?.unit?.toLowerCase() === "kg" && (data?.category?.name === "Film" || data?.category?.name === "Base Paper")) {
                    return {
                        ...ele,
                        [name]: name === "secondaryName" ? value : formattedValue,
                        inton: formattedValue / 1000,
                    };
                } else {
                    return {
                        ...ele,
                        [name]: name === "secondaryName" ? value : formattedValue,
                    };
                }
            } else {
                return { ...ele };
            }
        });

        setPurchaseOrderListData(updatedItems);
    };
    const handleDeleteItem = (row) => {
        const updatedItems = purchaseOrderListData?.filter((ele) => ele?.itemName !== row?.itemName)
        setPurchaseOrderListData(updatedItems)
    }

    const handleNext = () => {
        if (validStep()) {
            if (activeStep == 0) {
                setActiveStep((prev) => prev + 1)
            } else if (activeStep == 1) {
                _addUpdatePo()
            } else {
                setSelectedItem({})
                setIsOpenAddUpdatePO(false)
                _getPurchaseOrders();
                setData({})
            }
        }
    };
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const handleChange = (name, value) => {
        if (name == "isRuninngMeter") {
            setData({ ...data, [name]: value, runningMeter: "", })
        }
        else if (name == "poDate") {
            const poDate = value;
            const deliveryDate = new Date(poDate);
            deliveryDate.setDate(deliveryDate.getDate() + 15);

            setData({
                ...data,
                [name]: poDate,
                deliveryDate,
            });
        }
        else if (name == "isCore") {
            setData({ ...data, [name]: value, core: "" })
        }
        else if (name == "isProductionMonth") {
            setData({ ...data, [name]: value, productionMonth: "", productionYear: "" })
        } else if (name == "isAdditionalTermsAndCondition") {
            setData({ ...data, [name]: value, additionalTermsAndConditions: "" })
        } else if (name == "isPort") {
            setData({ ...data, [name]: value, port: "" })
        }
        else if (name == "port") {
            setData({ ...data, [name]: value, status: "" })
        }
        else if (name == "vendor") {
            setData({ ...data, [name]: value, })
            const options = value?.vendorType?.map((ele) => {
                return {
                    id: ele == "Local" ? 1 : 2,
                    name: ele
                }
            })
            setPOTypeOptions(options)
        }
        else {
            setData({ ...data, [name]: value })
        }
    }

    const createPurchaseOrder = () => {
        if (data?.allItems) {
            const newItem = {
                itemName: data.allItems?.itemName,
                quantity: "",
                secondaryName: data?.allItems?.secondaryName,
                unit: tableOptions?.unit?.unit || null,
                inton: null,
                ratePerUnit: "",
            };
            const isItemExists = purchaseOrderListData.some(order => order.itemName === newItem.itemName);
            if (isItemExists) {
                setSnackBar("error", "Item already exists.");
            } else {
                setPurchaseOrderListData(prevData => [...prevData, newItem]);
                setData({ ...data, allItems: "" })
            }
        } else {
            setSnackBar("error", "Please select an item.");
        }
    };

    //--------------------- Validation ------------------------------
    const validStep = () => {
        let error = {};
        let formIsValid = true;
        if (activeStep === 0) {
            if (!data?.vendor) {
                formIsValid = false;
                error[`vendor`] = `* Please select vendor.`;
            }
            if (!data?.vendorType || !data?.vendorType?.name) {
                formIsValid = false;
                error[`vendorType`] = `* Please select vendor type.`;
            }
            if (!data?.category || !data?.category?.name) {
                formIsValid = false;
                error[`category`] = `* Please select category.`;
            }
        }
        if (activeStep === 1) {
            if (!data?.poNumber?.trim()) {
                formIsValid = false;
                error[`poNumber`] = `* Please enter po number.`;
            }
            if (!data?.poDate) {
                formIsValid = false;
                error[`poDate`] = `* Please select po date.`;
            }
            if (data?.poDate) {
                if (!isCompleteDate(data?.poDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid po date")
                }
            }
            if (!data?.deliveryDate) {
                formIsValid = false;
                error[`deliveryDate`] = `* Please select delivery date.`;
            }
            if (data?.deliveryDate) {
                if (!isCompleteDate(data?.deliveryDate)) {
                    formIsValid = false;
                    setSnackBar("error", "Please select valid delivery date")
                }
            }
            if (!data?.defaultYear || !data?.defaultYear?.name?.trim()) {
                formIsValid = false;
                error[`defaultYear`] = `* Please select year.`;
            }
            // if (data?.category?.name == "Base Paper") {
            //     if (!data?.typeOfpaper) {
            //         formIsValid = false;
            //         error[`typeOfpaper`] = `* Please select type of paper.`;
            //     }
            //     if (!data?.color) {
            //         formIsValid = false;
            //         error[`color`] = `* Please select color.`;
            //     }
            // }
            // if (data?.category?.name == "Base Paper") {
            //     if (!data?.size) {
            //         formIsValid = false;
            //         error[`size`] = `* Please select size.`;
            //     }
            // }
            // if (data?.category?.name == "Film") {
            //     if (!data?.micron?.micron) {
            //         formIsValid = false;
            //         error[`micron`] = `* Please select micron.`;
            //     }
            //     if (!data?.coatingPreferences?.value) {
            //         formIsValid = false;
            //         error[`coatingPreferences`] = `* Please select coating preferences.`;
            //     }
            // }
            // if (data?.category?.name == "Chemical") {
            //     if (!data?.chemicalName?.chemicalName) {
            //         formIsValid = false;
            //         error[`chemicalName`] = `* Please select chemical name.`;
            //     }
            //     if (!data?.chemicalCategory?.chemicalCategory) {
            //         formIsValid = false;
            //         error[`chemicalCategory`] = `* Please select chemical category.`;
            //     }
            //     if (!data?.chemicalCode?.chemicalCode) {
            //         formIsValid = false;
            //         error[`chemicalCode`] = `* Please select chemical Code.`;
            //     }
            // }
            // if (data?.category?.name == "Ink") {
            //     if (!data?.inkName) {
            //         formIsValid = false;
            //         error[`inkName`] = `* Please select ink name.`;
            //     }
            //     if (!data?.pantoneNumber) {
            //         formIsValid = false;
            //         error[`pantoneNumber`] = `* Please select pantone number.`;
            //     }

            // }
            // if (data?.category?.name == "Packaging Material") {
            //     if (!data?.packagingName || !data?.packagingName?.itemName?.trim()) {
            //         formIsValid = false;
            //         error[`packagingName`] = `* Please select packaging name.`;
            //     }
            // }
            // if (data?.category?.name == "Other") {
            //     if (!data?.otherName || !data?.otherName?.itemName?.trim()) {
            //         formIsValid = false;
            //         error[`otherName`] = `* Please select other name.`;
            //     }
            // }
            // if (data?.category?.name == "Base Paper" || data?.category?.name == "Other") {
            //     if (!data?.subGroup) {
            //         formIsValid = false;
            //         error[`subGroup`] = `* Please select GSM.`;
            //     }
            // }
            // if (data?.category?.name == "Other") {
            //     if (!data?.group) {
            //         formIsValid = false;
            //         error[`group`] = `* Please select group.`;
            //     }
            // }
            if (data?.isRuninngMeter) {
                if (!data?.runningMeter?.trim()) {
                    formIsValid = false;
                    error.runningMeter = `* Please enter running meter.`;
                }
            }
            if (data?.isCore) {
                if (!data?.core?.trim()) {
                    formIsValid = false;
                    error.core = `* Please enter core.`;
                }
            }
            if (data?.isPort) {
                if (!data?.port?.label) {
                    formIsValid = false;
                    error.port = `* Please select port.`;
                }
                if (data?.port?.label) {
                    if (!data?.status) {
                        formIsValid = false;
                        error.status = `* Please select status.`;
                    }
                }

            }
            if (data?.vendorType?.id == 2) {
                if (data?.isProductionMonth) {
                    if (!data?.productionMonth || !data?.productionMonth?.name) {
                        formIsValid = false;
                        error[`productionMonth`] = `* Please select production month.`;
                    }
                    if (!data?.productionYear?.name) {
                        formIsValid = false;
                        error[`productionYear`] = `* Please select production year.`;
                    }
                }
            }
            if (data?.isAdditionalTermsAndCondition) {
                if (!data?.additionalTermsAndConditions || data?.additionalTermsAndConditions == "<p><br></p>") {
                    formIsValid = false;
                    error[`additionalTermsAndConditions`] = `* Please enter additional terms and conditions.`;
                }
            }
            if (purchaseOrderListData?.length == 0) {
                formIsValid = false;
                setSnackBar("error", "Please select item.")
            }
        }
        setErrors(error);
        return formIsValid;
    };


    // ============= add Inventory Field API =============
    const _downloadPO = async () => {
        setFullPageLoader(true);
        const body = {
            id: selectedItem?._id
        };
        const response = await dispatch(downloadPO(body));
        const error = await ErrorHandler(response, setSnackBar);
        if (error) {
            const blobData = response?.payload?.data;
            if (blobData) {
                const contentDisposition = response?.payload?.headers?.["content-disposition"];
                const filename =
                    contentDisposition?.split("filename=")?.[1]?.split(";")?.[0]?.replace(/['"]/g, "") ||
                    "Purchase_Order.docx";
                downloadFileFromBlob(blobData, filename);
                setFullPageLoader(false);
            } else {
                setFullPageLoader(false);
                setSnackBar("error", response?.payload?.message || "Something went wrong!");
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // const _downloadPO = (base64Data, fileName = "document.pdf") => {
    //     const base64String = base64Data.split(",")[1];

    //     // Convert Base64 to binary data
    //     const byteCharacters = atob(base64String);
    //     const byteNumbers = new Array(byteCharacters.length);

    //     for (let i = 0; i < byteCharacters.length; i++) {
    //         byteNumbers[i] = byteCharacters.charCodeAt(i);
    //     }

    //     const byteArray = new Uint8Array(byteNumbers);

    //     // Create a Blob with MIME type application/pdf
    //     const blob = new Blob([byteArray], { type: "application/pdf" });

    //     // Generate Blob URL
    //     const blobURL = URL.createObjectURL(blob);

    //     // Create a hidden download link
    //     const a = document.createElement("a");
    //     a.href = blobURL;
    //     a.download = fileName;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);

    //     // Revoke the Blob URL to free memory
    //     URL.revokeObjectURL(blobURL);
    // };

    // ============= add Inventory Field API =============
    const _addUpdatePo = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "vendorName": data?.vendor?.name,
                "vendorType": data?.vendorType?.id,
                "category": data?.category?.id,
                "poNumber": data?.poNumber,
                "poDate": data.poDate ? dayjs(data.poDate).format("YYYY-MM-DD") : null,
                "deliveryDate": data.deliveryDate ? dayjs(data.deliveryDate).format("YYYY-MM-DD") : null,
                "defaultYear": data?.defaultYear?.name,
                "runningMeter": data?.runningMeter || null,
                "core": data?.core || null,
                // "group": data?.group?.group,
                // "size": data?.size?.size,
                // "subGroup": data?.subGroup?.subGroup,
                // "paperType": data?.typeOfpaper?.paperType,
                // "color": data?.color?.color,
                // "micron": data?.micron?.micron,
                // "coatingPreferences": data?.coatingPreferences?.value,
                // "chemicalName": data?.chemicalName?.chemicalName,
                // "chemicalCode": String(data?.chemicalCode?.chemicalCode),
                // "categoryName": data?.chemicalCategory?.chemicalCategory,
                // "pantoneNumber": data?.pantoneNumber?.pantoneNumber,
                "moneyType": tableOptions?.currency?.name,
                // "itemName": data?.category?.name == "Ink" ? data?.inkName?.itemName : data?.category?.name == "Packaging Material" ? data?.packagingName?.itemName : data?.category?.name == "Other" ? data?.otherName?.itemName : null,
                "unitType": tableOptions?.unit?.unit,
                "purchaseOrder": purchaseOrderListData,
                "productionMonth": data?.productionMonth?.name || null,
                "productionYear": data?.productionYear?.name || null,
                "description": data?.additionalTermsAndConditions,
                "port": data?.port?.label,
                "portData": data?.status,
                "selectedCondition": data?.selectedCondition,
                // "paymentDescription": data?.additionalPaymentCondition,
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updatePurchaseOrder : addPurchaseOrder
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message)
                    setActiveStep((prev) => prev + 1)
                    setBase64(response?.payload?.data?.blob)
                    setSelectedItem(response?.payload?.data?.response)
                    setPoResponse(response?.payload?.data?.response)
                    setSearchValue("")
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };
    // ============== Get Vendor API ==============
    const _getVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : vendorPage,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        { (vendorList?.length !== vendorTotalCount) && setVendorPage(vendorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText ? searchText : "");
            setVendorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setVendorList([...vendorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        setVendorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText);
            setVendorList(response?.payload?.data?.response);
        }
    };

    //------------------  Group API ------------------
    const _getGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Group"],
            "limit": 10,
            "page": p ? p : groupPage,
            "status": 1,
            "search": searchText ? searchText : ""
        }
        response = await dispatch(getInventoryFields(body));
        { (groupList?.length !== grouptotalCount) && setGroupPage(groupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchGroup(searchText ? searchText : "");
            setGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setGroupList([...groupList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Group"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        }
        response = await dispatch(getInventoryFields(body));
        setGroupPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchGroup(searchText);
            setGroupList(response?.payload?.data?.response)
        }
    };

    //------------------ Sub Group API ------------------
    const _getSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p ? p : subGroupPage,
            "status": 1,
            "search": searchText ? searchText : ""
        }
        response = await dispatch(getInventoryFields(body));
        { (subGroupList?.length !== subGrouptotalCount) && setSubGroupPage(subGroupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText ? searchText : "");
            setSubGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setSubGroupList([...subGroupList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        }
        response = await dispatch(getInventoryFields(body));
        setSubGroupPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText);
            setSubGroupList(response?.payload?.data?.response)
        }
    };

    //------------------  Type Of Paper API ------------------
    const _getTypeOfpaper = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["TypeOfPaper"],
            "limit": 10,
            "page": p ? p : typeOfpaperPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (typeOfpaperList?.length !== typeOfpapertotalCount) && setTypeOfpaperPage(typeOfpaperPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchTypeOfpaper(searchText ? searchText : "");
            setTypeOfpaperTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setTypeOfpaperList([...typeOfpaperList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForTypeOfpaper = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["TypeOfPaper"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setTypeOfpaperPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchTypeOfpaper(searchText);
            setTypeOfpaperList(response?.payload?.data?.response);
        }
    };

    //------------------  Color API ------------------
    const _getColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p ? p : colorPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (colorList?.length !== colorTotalCount) && setColorPage(colorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText ? searchText : "");
            setColorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setColorList([...colorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setColorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText);
            setColorList(response?.payload?.data?.response);
        }
    };

    //------------------  Size API ------------------
    const _getSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p ? p : sizePage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (sizeList?.length !== sizeTotalCount) && setSizePage(sizePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText ? searchText : "");
            setSizeTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setSizeList([...sizeList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForSize = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Size"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setSizePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSize(searchText);
            setSizeList(response?.payload?.data?.response);
        }
    };


    //------------------  Micron API ------------------
    const _getMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p ? p : micronPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (micronList?.length !== micronTotalCount) && setMicronPage(micronPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText ? searchText : "");
            setMicronTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setMicronList([...micronList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setMicronPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText);
            setMicronList(response?.payload?.data?.response);
        }
    };

    //------------------  Chemical API ------------------
    const _getChemical = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalName"],
            "limit": 10,
            "page": p ? p : chemicalPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (chemicalList?.length !== chemicalTotalCount) && setChemicalPage(chemicalPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemical(searchText ? searchText : "");
            setChemicalTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setChemicalList([...chemicalList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForChemical = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalName"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setChemicalPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemical(searchText);
            setChemicalList(response?.payload?.data?.response);
        }
    };

    //------------------  Chemical Category API ------------------
    const _getChemicalCategory = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalCategory"],
            "limit": 10,
            "page": p ? p : chemicalCategoryPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (chemicalCategoryList?.length !== chemicalCategoryTotalCount) && setChemicalCategoryPage(chemicalCategoryPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemicalCategory(searchText ? searchText : "");
            setChemicalCategoryTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setChemicalCategoryList([...chemicalCategoryList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForChemicalCategory = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["ChemicalCategory"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setChemicalCategoryPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchChemicalCategory(searchText);
            setChemicalCategoryList(response?.payload?.data?.response);
        }
    };

    //------------------  Chemical Code API ------------------
    // const _getChemicalCode = async (p, searchText) => {
    //     let response;
    //     let body = {
    //         "inventoryFieldType": InventoryTypeInum["ChemicalCode"],
    //         "limit": 10,
    //         "page": p ? p : chemicalCodePage,
    //         "status": 1,
    //     };
    //     response = await dispatch(getInventoryFields(body));
    //     { (chemicalCodeList?.length !== chemicalCodeTotalCount) && setChemicalCodePage(chemicalCodePage + 1) }
    //     let error = await ErrorHandler(response, setSnackBar);
    //     if (error) {
    //         setSearchChemicalCode(searchText ? searchText : "");
    //         setChemicalCodeTotalCount(response?.payload?.data?.count);
    //         if (response?.payload?.data) {
    //             setChemicalCodeList([...chemicalCodeList, ...response?.payload?.data?.response]);
    //         }
    //     }
    // };
    // const handleChangeInputForChemicalCode = async (p, searchText) => {
    //     let response;
    //     let body = {
    //         "inventoryFieldType": InventoryTypeInum["ChemicalCode"],
    //         "limit": 10,
    //         "page": p,
    //         "status": 1,
    //     };
    //     response = await dispatch(getInventoryFields(body));
    //     setChemicalCodePage(2);
    //     let error = await ErrorHandler(response, setSnackBar);
    //     if (error) {
    //         setSearchChemicalCode(searchText);
    //         setChemicalCodeList(response?.payload?.data?.response);
    //     }
    // };

    //------------------  Pantone Number API ------------------
    const _getPantoneNumber = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["PantoneNumber"],
            "limit": 10,
            "page": p ? p : pantoneNumberPage,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (pantoneNumberList?.length !== pantoneNumberTotalCount) && setPantoneNumberPage(pantoneNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPantoneNumber(searchText ? searchText : "");
            setPantoneNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setPantoneNumberList([...pantoneNumberList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForPantoneNumber = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["PantoneNumber"],
            "limit": 10,
            "page": p,
            "status": 1,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setPantoneNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPantoneNumber(searchText);
            setPantoneNumberList(response?.payload?.data?.response);
        }
    };

    //------------------  Unit API ------------------
    const _getUnit = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Unit"],
            "limit": 10,
            "page": p ? p : unitPage,
            // "status": 2,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        { (unitList?.length !== unitTotalCount) && setUnitPage(unitPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchUnit(searchText ? searchText : "");
            setUnitTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setUnitList([...unitList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForUnit = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Unit"],
            "limit": 10,
            "page": p,
            // "status": 2,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getInventoryFields(body));
        setUnitPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchUnit(searchText);
            setUnitList(response?.payload?.data?.response);
        }
    };


    //------------------  Ink Name API ------------------
    const _getInkName = async (p, searchText) => {
        let response;
        let body = {
            "category": 4, //for Ink category 4
            "limit": 10,
            "page": p ? p : inkNamePage,
        };
        response = await dispatch(getAllItemName(body));
        { (inkNameList?.length !== inkNameTotalCount) && setInkNamePage(inkNamePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchInkName(searchText ? searchText : "");
            setInkNameTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setInkNameList([...inkNameList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForInkName = async (p, searchText) => {
        let response;
        let body = {
            "category": 4, //for Ink category 4
            "limit": 10,
            "page": p,
        };
        response = await dispatch(getAllItemName(body));
        setInkNamePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchInkName(searchText);
            setInkNameList(response?.payload?.data?.response);
        }
    };


    //------------------  Group API ------------------
    const _getPackaging = async (p, searchText) => {
        let response;
        let body = {
            "category": 5,//for packaging category 5
            "limit": 10,
            "page": p ? p : packagingPage,
        };
        response = await dispatch(getAllItemName(body));
        if (packagingList?.length !== packagingTotalCount) {
            setPackagingPage(packagingPage + 1);
        }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPackaging(searchText ? searchText : "");
            setPackagingTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setPackagingList([...packagingList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForPackaging = async (p, searchText) => {
        let response;
        let body = {
            "category": 5, //for packaging category 5
            "limit": 10,
            "page": p,
        };
        response = await dispatch(getAllItemName(body));
        setPackagingPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPackaging(searchText);
            setPackagingList(response?.payload?.data?.response);
        }
    };


    //------------------  Group API ------------------
    const _getOtherName = async (p, searchText) => {
        let response;
        let body = {
            "category": 6, //for packaging category 6
            "limit": 10,
            "page": p ? p : otherNamePage,
        }
        response = await dispatch(getAllItemName(body));
        { (otherNameList?.length !== otherNameTotalCount) && setOtherNamePage(otherNamePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchOtherName(searchText ? searchText : "");
            setOtherNameTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setOtherNameList([...otherNameList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForOtherName = async (p, searchText) => {
        let response;
        let body = {
            "category": 6, //for packaging category 6
            "limit": 10,
            "page": p,
        }
        response = await dispatch(getAllItemName(body));
        setOtherNamePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchOtherName(searchText);
            setOtherNameList(response?.payload?.data?.response);
        }
    };



    //------------------  Group API ------------------
    const _getAllItems = async (p, searchText) => {
        let response;
        let body;
        if (data?.category?.name === "Base Paper") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.subGroup?.subGroup && { "subGroup": data?.subGroup?.subGroup }),
                ...(isAppliedFilter && data?.typeOfpaper?.paperType && { "paperType": data?.typeOfpaper?.paperType }),
                ...(isAppliedFilter && data?.color?.color && { "color": data?.color?.color }),
                ...(isAppliedFilter && data?.size?.size && { "size": data?.size?.size }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Film") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.micron?.micron && { "micron": data?.micron?.micron }),
                ...(isAppliedFilter && data?.coatingPreferences?.value && { "coatingPreferences": data?.coatingPreferences?.value }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Chemical") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.chemicalName?.chemicalName && { "chemicalName": data?.chemicalName?.chemicalName }),
                ...(isAppliedFilter && data?.chemicalCode?.chemicalCode && { "chemicalCode": data?.chemicalCode?.chemicalCode }),
                ...(isAppliedFilter && data?.chemicalCategory?.chemicalCategory && { "chemicalCategory": data?.chemicalCategory?.chemicalCategory }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Ink") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.pantoneNumber?.inkName && { "inkName": data?.pantoneNumber?.inkName }),
                ...(isAppliedFilter && data?.inkName?.itemName && { "itemName": data?.inkName?.itemName }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Packaging Material") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.packagingName?.itemName && { "itemName": data?.packagingName?.itemName }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        } else {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.subGroup?.subGroup && { "subGroup": data?.subGroup?.subGroup }),
                ...(isAppliedFilter && data?.otherName?.itemName && { "itemName": data?.otherName?.itemName }),
                "limit": 10,
                "page": p ? p : allItemsPage,
                "search": searchText ? searchText : ""
            }
        }
        response = await dispatch(getAllItemsByCategory(body));
        { (allItemsList?.length !== allItemsTotalCount) && setAllItemsPage(allItemsPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText ? searchText : "");
            setAllItemsTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data?.count != allItemsList?.length) {
                if (response?.payload?.data?.response?.length !== 0) {
                    if (p === 1) {
                        setAllItemsList(response?.payload?.data?.response);
                    } else {
                        setAllItemsList([...allItemsList, ...response?.payload?.data?.response]);
                    }
                } else {
                    setAllItemsList([])
                }
            }
        }
    };

    const handleChangeInputForAllItems = async (p, searchText) => {
        let response;
        let body;
        if (data?.category?.name === "Base Paper") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.subGroup?.subGroup && { "subGroup": data?.subGroup?.subGroup }),
                ...(isAppliedFilter && data?.typeOfpaper?.paperType && { "paperType": data?.typeOfpaper?.paperType }),
                ...(isAppliedFilter && data?.color?.color && { "color": data?.color?.color }),
                ...(isAppliedFilter && data?.size?.size && { "size": data?.size?.size }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Film") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.micron?.micron && { "micron": data?.micron?.micron }),
                ...(isAppliedFilter && data?.coatingPreferences?.value && { "coatingPreferences": data?.coatingPreferences?.value }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Chemical") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.chemicalName?.chemicalName && { "chemicalName": data?.chemicalName?.chemicalName }),
                ...(isAppliedFilter && data?.chemicalCode?.chemicalCode && { "chemicalCode": data?.chemicalCode?.chemicalCode }),
                ...(isAppliedFilter && data?.chemicalCategory?.chemicalCategory && { "chemicalCategory": data?.chemicalCategory?.chemicalCategory }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Ink") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.pantoneNumber?.inkName && { "inkName": data?.pantoneNumber?.inkName }),
                ...(isAppliedFilter && data?.inkName?.itemName && { "itemName": data?.inkName?.itemName }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        } else if (data?.category?.name === "Packaging Material") {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.packagingName?.itemName && { "itemName": data?.packagingName?.itemName }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        } else {
            body = {
                "category": data?.category?.id,
                ...(isAppliedFilter && data?.subGroup?.subGroup && { "subGroup": data?.subGroup?.subGroup }),
                ...(isAppliedFilter && data?.otherName?.itemName && { "itemName": data?.otherName?.itemName }),
                "limit": 10,
                "page": p,
                "search": searchText ? searchText : ""
            }
        }
        response = await dispatch(getAllItemsByCategory(body));
        setAllItemsPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAllItems(searchText);
            setAllItemsList(response?.payload?.data?.response);
        }
    };


    const filterApiCall = () => {
        if (data?.category?.name == "Base Paper") {
            // if (data?.group && data?.subGroup && data?.typeOfpaper) {
            // if (data?.subGroup && data?.typeOfpaper && data?.color && data?.size) {
            handleChangeInputForAllItems(1);
            // }
        }
        if (data?.category?.name == "Film") {
            // if (data?.micron && data?.coatingPreferences) {
            handleChangeInputForAllItems(1);
            // }
        }
        if (data?.category?.name == "Chemical") {
            // if (data?.chemicalName && data?.chemicalCategory && data?.chemicalCode) {
            handleChangeInputForAllItems(1);
            // }
        }
        if (data?.category?.name == "Ink") {
            // if (data?.pantoneNumber && data?.inkName) {
            handleChangeInputForAllItems(1);
            // }
        }
        if (data?.category?.name == "Packaging Material") {
            // if (data?.packagingName) {
            handleChangeInputForAllItems(1);
            // }
        }
        if (data?.category?.name == "Other") {
            // if (data?.group && data?.subGroup && data?.otherName) {
            // if (data?.subGroup && data?.otherName) {
            handleChangeInputForAllItems(1);
            // }
        }
    }

    // ====================== Use Effects ======================

    useEffect(() => {
        if (isAppliedFilter) {
            filterApiCall();
        }
        // }, [data?.category, isAppliedFilter, data?.coatingPreferences, data?.size, data?.color, data?.subGroup, data?.otherName, data?.packagingName, data?.pantoneNumber, data?.inkName, data?.chemicalName, data?.chemicalCategory, data?.micron, data?.typeOfpaper])
    }, [isAppliedFilter])

    useEffect(() => {
        if (activeStep === 1 && data?.category?.id) {
            setAllItemsList([]);
            setAllItemsPage(1);
            _getAllItems(1);
        }
    }, [activeStep, data?.category?.id]);
    useEffect(() => {
        if (!data?.isProductionMonth) {
            setData({ ...data, productionMonth: null, productionYear: null })
        }
    }, [data?.isProductionMonth])
    useEffect(() => {
        if (!data?.isAdditionalTermsAndCondition) {
            setData({ ...data, additionalTermsAndConditions: null })
        }
    }, [data?.isAdditionalTermsAndCondition])
    useEffect(() => {
        if (!data?.isAdditionalPaymentCondition) {
            setData({ ...data, additionalPaymentCondition: null })
        }
    }, [data?.isAdditionalPaymentCondition])

    useEffect(() => {
        _getVendor();
        _getGroup();
        _getSubGroup();
        _getTypeOfpaper();
        _getColor();
        _getSize();
        _getMicron();
        _getChemical();
        _getChemicalCategory();
        // _getChemicalCode();
        _getPantoneNumber();
        _getInkName();
        _getPackaging();
        _getOtherName();
        _getUnit();
    }, [])


    useEffect(() => {
        setVendorOptions(vendorList?.map((e) => e));
    }, [vendorList]);

    useEffect(() => {
        setGroupOptions(groupList?.map((e) => e));
    }, [groupList]);

    useEffect(() => {
        setColorOptions(colorList?.map((e) => e));
    }, [colorList]);

    useEffect(() => {
        setSubGroupOptions(subGroupList?.map((e) => e));
    }, [subGroupList]);

    useEffect(() => {
        setTypeOfpaperOptions(typeOfpaperList?.map((e) => e));
    }, [typeOfpaperList]);

    useEffect(() => {
        setSizeOptions(sizeList?.map((e) => e));
    }, [sizeList]);

    useEffect(() => {
        setMicronOptions(micronList?.map((e) => e));
    }, [micronList]);

    useEffect(() => {
        setChemicalOptions(chemicalList?.map((e) => e));
    }, [chemicalList]);

    // useEffect(() => {
    //     setChemicalCodeOptions(chemicalCodeList?.map((e) => e));
    // }, [chemicalCodeList]);

    useEffect(() => {
        setChemicalCategoryOptions(chemicalCategoryList?.map((e) => e));
    }, [chemicalCategoryList]);

    useEffect(() => {
        setPantoneNumberOptions(pantoneNumberList?.map((e) => e));
    }, [pantoneNumberList]);

    useEffect(() => {
        setInkNameOptions(inkNameList?.map((e) => e));
    }, [inkNameList]);

    useEffect(() => {
        setPackagingOptions(packagingList?.map((e) => e));
    }, [packagingList]);

    useEffect(() => {
        setOtherNameOptions(otherNameList?.map((e) => e));
    }, [otherNameList]);

    useEffect(() => {
        // Frontend-side search filtering
        if (searchAllItems && searchAllItems.trim()) {
            const searchLower = searchAllItems.toLowerCase();
            const filteredItems = allItemsList?.filter((item) => {
                const itemName = item?.itemName?.toLowerCase() || "";
                const secondaryName = item?.secondaryName?.toLowerCase() || "";
                return itemName.includes(searchLower) || secondaryName.includes(searchLower);
            });
            setAllItemsOptions(filteredItems?.map((e) => e));
        } else {
            setAllItemsOptions(allItemsList?.map((e) => e));
        }
    }, [allItemsList, searchAllItems]);

    useEffect(() => {
        setUnitOptions(unitList?.map((e) => e));
    }, [unitList]);

    // useEffect(() => {
    //     const currentYear = new Date().getFullYear();
    //     const years = Array.from({ length: 5 }, (_, i) => {
    //         const startYear = currentYear + (i - 1);
    //         const endYear = startYear + 1;
    //         return {
    //             id: `${startYear}-${endYear.toString().slice(-2)}`,
    //             name: `${startYear}-${endYear.toString().slice(-2)}`,
    //         };
    //     });
    //     setYearOptions(years);
    //     setData({ ...data, defaultYear: years[0] })
    // }, []);
    useEffect(() => {
        if (!data?.poDate) return;

        const poDate = new Date(data.poDate); // ISO string like "2025-06-22T00:00:00.000Z"
        if (isNaN(poDate.getTime())) return;

        const month = poDate.getMonth(); // 0 = Jan, 3 = Apr
        const year = poDate.getFullYear();

        // Determine start of financial year
        const startFY = month >= 3 ? year : year - 1;

        const years = Array.from({ length: 5 }, (_, i) => {
            const fyStart = startFY + i;
            const fyEnd = fyStart + 1;
            return {
                id: `${fyStart}-${fyEnd.toString().slice(-2)}`,
                name: `${fyStart}-${fyEnd.toString().slice(-2)}`
            };
        });

        setYearOptions(years);
        setData((prev) => ({ ...prev, defaultYear: years[0] }));
    }, [data?.poDate]);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 5 }, (_, i) => {
            const startYear = currentYear + (i - 1);
            return {
                id: String(startYear),
                name: String(startYear),
            };
        });
        setYearOptionsForProduction(years);
    }, []);

    return (
        <Box display={"flex"}>
            <Box sx={{ minWidth: "275px", height: "calc(100vh - 84px)", backgroundColor: "#E2E4F8" }}>
                <Stepper
                    activeStep={activeStep}
                    orientation="vertical"
                    className={muiClasses.stepper_main}
                    connector={<CustomStepConnector />}
                >
                    {steps.map((label, index) => (
                        <Step key={index}>
                            <StepLabel StepIconComponent={StepIcon}>{label.name}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
                <Grid item xs={12}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`${selectedItem?._id ? "Edit" : "Create New"} PO`}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px", maxHeight: "64vh", overflowY: "auto" }}>
                        {activeStep == 0 ?
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> Basic Details</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonAutoComplete
                                        valid
                                        label="Vendor"
                                        placeholder="Select Vendor"
                                        options={vendorOptions || []}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={data?.vendor || null}
                                        disabled={selectedItem?._id}
                                        onChange={(e, newValue) => handleChange("vendor", newValue)}
                                        loadData={(vendorOptions?.length !== vendorTotalCount) ? _getVendor : undefined}
                                        handleSearch={(e) => handleChangeInputForVendor(1, e?.target?.value)}
                                        searchValue={searchVendor}
                                    />
                                    <ErrorMessage text={(!data?.vendor) ? errors?.vendor : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonAutoComplete
                                        valid
                                        label="Local / import"
                                        placeholder="Select Vendor Type"
                                        options={POTypeOptions || []}
                                        disabled={!data?.vendor || selectedItem?._id}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={data?.vendorType || null}
                                        onChange={(e, newValue) => handleChange("vendorType", newValue)}
                                    />
                                    <ErrorMessage text={(!data?.vendorType || !data?.vendorType?.name) ? errors?.vendorType : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonAutoComplete
                                        valid
                                        label="Category"
                                        placeholder="Select Category"
                                        options={categoryNameOptions || []}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={data?.category || null}
                                        onChange={(e, newValue) => { updateOtherValue(newValue) }}
                                    />
                                    <ErrorMessage text={(!data?.category || !data?.category?.name) ? errors?.category : ""} />
                                </Grid>
                            </Grid>
                            : activeStep == 1 ?
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}> {data?.category?.name} PO</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <CommonTextField
                                            valid
                                            type="number"
                                            label="Po Number"
                                            name="poNumber"
                                            value={data?.poNumber}
                                            placeholder="Enter The PO number"
                                            onChange={(e) => {
                                                if (+e?.target?.value >= 0) {
                                                    handleChange("poNumber", e.target.value)
                                                } else {
                                                    return;
                                                }
                                            }}
                                        />
                                        <ErrorMessage text={(!data?.poNumber?.trim()) ? errors?.poNumber : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <CommonDatePicker
                                            valid
                                            width="100%"
                                            label={"PO Date"}
                                            onChange={(value) => handleChange("poDate", value)}
                                            value={data?.poDate || null}
                                            name={"poDate"}
                                        />
                                        <ErrorMessage text={(!data?.poDate) ? errors?.poDate : ""} />
                                    </Grid>

                                    <Grid item xs={12} sm={6} lg={4}>
                                        <CommonAutoComplete
                                            valid
                                            label="Year"
                                            placeholder="Select Year"
                                            options={yearOptions || []}
                                            disabled
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={data?.defaultYear || null}
                                            onChange={(e, newValue) => handleChange("defaultYear", newValue)}
                                        />
                                        <ErrorMessage text={(!data?.defaultYear || !data?.defaultYear?.name?.trim()) ? errors?.defaultYear : ""} />
                                    </Grid>
                                    <Grid item xs={12} sm={6} lg={4}>
                                        <CommonDatePicker
                                            valid
                                            label={"Delivery Date"}
                                            onChange={(value) => handleChange("deliveryDate", value)}
                                            value={data?.deliveryDate || null}
                                            name={"deliveryDate"}
                                        />
                                        <ErrorMessage text={(!data?.deliveryDate) ? errors?.deliveryDate : ""} />
                                    </Grid>
                                    {/* {data?.category?.name === "Other" &&
                                        <Grid item xs={12} sm={6} lg={4}>
                                            <CommonAutoComplete
                                                valid
                                                label="Group"
                                                placeholder="Select Group"
                                                options={groupOptions || []}
                                                getOptionLabel={(option) => option?.group || ""}
                                                value={data?.group || null}
                                                onChange={(e, newValue) => handleChange("group", newValue)}
                                                loadData={(groupOptions?.length !== grouptotalCount) ? _getGroup : undefined}
                                                handleSearch={(e) => handleChangeInputForGroup(1, e?.target?.value)}
                                                searchValue={searchGroup}
                                            />
                                            <ErrorMessage text={data?.category?.name === "Other" && !data?.group ? errors?.group : ""} />
                                        </Grid>
                                    } */}
                                    <Grid item xs={12}>
                                        <Box border={'1px solid #CDCDCD'} borderRadius={'10px'} width={'100%'}>
                                            <Grid container spacing={2} p={2}>
                                                {(data?.category?.name === "Base Paper" || data?.category?.name === "Other") &&
                                                    <>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="GSM"
                                                                placeholder="Select GSM"
                                                                options={subGroupOptions || []}
                                                                getOptionLabel={(option) => option?.subGroup || ""}
                                                                value={data?.subGroup || null}
                                                                onChange={(e, newValue) => handleChange("subGroup", newValue)}
                                                                loadData={(subGroupOptions?.length !== subGrouptotalCount) ? _getSubGroup : undefined}
                                                                handleSearch={(e) => handleChangeInputForSubGroup(1, e?.target?.value)}
                                                                searchValue={searchSubGroup}
                                                            />
                                                            <ErrorMessage text={((data?.category?.name === "Base Paper" || data?.category?.name === "Other") && (!data?.subGroup)) ? errors?.subGroup : ""} />
                                                        </Grid>
                                                    </>
                                                }
                                                {data?.category?.name === "Base Paper" &&
                                                    <>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Type Of Paper"
                                                                placeholder="Select Type Of Paper"
                                                                options={typeOfpaperOptions || []}
                                                                getOptionLabel={(option) => option?.paperType || ""}
                                                                value={data?.typeOfpaper || null}
                                                                onChange={(e, newValue) => handleChange("typeOfpaper", newValue)}
                                                                loadData={(typeOfpaperOptions?.length !== typeOfpapertotalCount) ? _getTypeOfpaper : undefined}
                                                                handleSearch={(e) => handleChangeInputForTypeOfpaper(1, e?.target?.value)}
                                                                searchValue={searchTypeOfpaper}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Base Paper" && (!data?.typeOfpaper)) ? errors?.typeOfpaper : ""} />
                                                        </Grid>

                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Color"
                                                                placeholder="Select Color"
                                                                options={colorOptions || []}
                                                                getOptionLabel={(option) => option?.color || ""}
                                                                value={data?.color || null}
                                                                onChange={(e, newValue) => handleChange("color", newValue)}
                                                                loadData={(colorOptions?.length !== colorTotalCount) ? _getColor : undefined}
                                                                handleSearch={(e) => handleChangeInputForColor(1, e?.target?.value)}
                                                                searchValue={searchColor}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Base Paper" && (!data?.color)) ? errors?.color : ""} />
                                                        </Grid>

                                                    </>
                                                }

                                                {(data?.category?.name === "Base Paper") &&
                                                    <>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Size"
                                                                placeholder="Select Size"
                                                                options={sizeOptions || []}
                                                                getOptionLabel={(option) => `${option?.size} (${option?.sizeUnit})` || ""}
                                                                value={data?.size || null}
                                                                onChange={(e, newValue) => handleChange("size", newValue)}
                                                                loadData={(sizeOptions?.length !== sizeTotalCount) ? _getSize : undefined}
                                                                handleSearch={(e) => handleChangeInputForSize(1, e?.target?.value)}
                                                                searchValue={searchSize}
                                                            />
                                                            <ErrorMessage text={((data?.category?.name === "Base Paper") && (!data?.size)) ? errors?.size : ""} />
                                                        </Grid>
                                                    </>
                                                }
                                                {data?.category?.name === "Film" &&
                                                    <>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Micron"
                                                                placeholder="Select Micron"
                                                                options={micronOptions || []}
                                                                getOptionLabel={(option) => option?.micron || ""}
                                                                value={data?.micron || null}
                                                                onChange={(e, newValue) => handleChange("micron", newValue)}
                                                                loadData={(micronOptions?.length !== micronTotalCount) ? _getMicron : undefined}
                                                                handleSearch={(e) => handleChangeInputForMicron(1, e?.target?.value)}
                                                                searchValue={searchMicron}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Film" && (!data?.micron?.micron)) ? errors?.micron : ""} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Coating Preferences"
                                                                placeholder="Select Coating Preferences"
                                                                options={coatingPreferencesOptions || []}
                                                                getOptionLabel={(option) => option?.label || ""}
                                                                value={data?.coatingPreferences || null}
                                                                onChange={(e, newValue) => handleChange("coatingPreferences", newValue)}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Film" && (!data?.coatingPreferences?.value)) ? errors?.coatingPreferences : ""} />
                                                        </Grid>

                                                    </>
                                                }
                                                {data?.category?.name === "Chemical" &&
                                                    <>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Chemical Name"
                                                                placeholder="Select Chemical"
                                                                options={chemicalOptions || []}
                                                                getOptionLabel={(option) => option?.chemicalName || ""}
                                                                value={data?.chemicalName || null}
                                                                onChange={(e, newValue) => handleChange("chemicalName", newValue)}
                                                                loadData={(chemicalOptions?.length !== chemicalTotalCount) ? _getChemical : undefined}
                                                                handleSearch={(e) => handleChangeInputForChemical(1, e?.target?.value)}
                                                                searchValue={searchChemical}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Chemical" && (!data?.chemicalName?.chemicalName)) ? errors?.chemicalName : ""} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Chemical Category"
                                                                placeholder="Select Chemical Category"
                                                                options={chemicalCategoryOptions || []}
                                                                getOptionLabel={(option) => option?.chemicalCategory || ""}
                                                                value={data?.chemicalCategory || null}
                                                                onChange={(e, newValue) => handleChange("chemicalCategory", newValue)}
                                                                loadData={(chemicalCategoryOptions?.length !== chemicalCategoryTotalCount) ? _getChemicalCategory : undefined}
                                                                handleSearch={(e) => handleChangeInputForChemicalCategory(1, e?.target?.value)}
                                                                searchValue={searchChemicalCategory}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Chemical" && (!data?.chemicalCategory?.chemicalCategory)) ? errors?.chemicalCategory : ""} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Chemical Code"
                                                                placeholder="Select Chemical Code"
                                                                options={chemicalOptions || []}
                                                                getOptionLabel={(option) => option?.chemicalCode || ""}
                                                                value={data?.chemicalCode || null}
                                                                onChange={(e, newValue) => handleChange("chemicalCode", newValue)}
                                                                loadData={(chemicalOptions?.length !== chemicalTotalCount) ? _getChemical : undefined}
                                                                handleSearch={(e) => handleChangeInputForChemical(1, e?.target?.value)}
                                                                searchValue={searchChemical}
                                                            />
                                                            {/* <CommonAutoComplete
                                                                label="Chemical Code"
                                                                placeholder="Select Chemical Code"
                                                                options={chemicalCodeOptions || []}
                                                                getOptionLabel={(option) => option?.chemicalCode || ""}
                                                                value={data?.chemicalCode || null}
                                                                onChange={(e, newValue) => handleChange("chemicalCode", newValue)}
                                                                loadData={(chemicalCodeOptions?.length !== chemicalCodeTotalCount) ? _getChemicalCode : undefined}
                                                                handleSearch={(e) => handleChangeInputForChemicalCode(1, e?.target?.value)}
                                                                searchValue={searchChemicalCode}
                                                            /> */}
                                                            <ErrorMessage text={(data?.category?.name === "Chemical" && (!data?.chemicalCode?.chemicalCode)) ? errors?.chemicalCode : ""} />
                                                        </Grid>
                                                    </>
                                                }
                                                {data?.category?.name === "Ink" &&
                                                    <>
                                                        {/* <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Ink Name"
                                                                placeholder="Select Ink Name"
                                                                options={inkNameOptions || []}
                                                                getOptionLabel={(option) => option?.itemName || ""}
                                                                value={data?.inkName || null}
                                                                onChange={(e, newValue) => handleChange("inkName", newValue)}
                                                                loadData={(inkNameOptions?.length !== inkNameTotalCount) ? _getInkName : undefined}
                                                                handleSearch={(e) => handleChangeInputForInkName(1, e?.target?.value)}
                                                                searchValue={searchInkName}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Ink" && (!data?.inkName || !data?.inkName?.itemName?.trim())) ? errors?.inkName : ""} />
                                                        </Grid> */}
                                                        <Grid item xs={12} sm={6} lg={4}>
                                                            <CommonAutoComplete
                                                                label="Ink Name"
                                                                placeholder="Select Ink Name"
                                                                options={pantoneNumberOptions || []}
                                                                getOptionLabel={(option) => option?.inkName || ""}
                                                                value={data?.pantoneNumber || null}
                                                                onChange={(e, newValue) => handleChange("pantoneNumber", newValue)}
                                                                loadData={(pantoneNumberOptions?.length !== pantoneNumberTotalCount) ? _getPantoneNumber : undefined}
                                                                handleSearch={(e) => handleChangeInputForPantoneNumber(1, e?.target?.value)}
                                                                searchValue={searchPantoneNumber}
                                                            />
                                                            <ErrorMessage text={(data?.category?.name === "Ink" && (!data?.pantoneNumber)) ? errors?.pantoneNumber : ""} />
                                                        </Grid>
                                                    </>
                                                }
                                                {data?.category?.name === "Packaging Material" &&
                                                    <Grid item xs={12} sm={6} lg={4}>
                                                        <CommonAutoComplete
                                                            label="Packaging Name"
                                                            placeholder="Select Packaging Name"
                                                            options={packagingOptions || []}
                                                            getOptionLabel={(option) => option?.itemName || ""}
                                                            value={data?.packagingName || null}
                                                            onChange={(e, newValue) => handleChange("packagingName", newValue)}
                                                            loadData={(packagingOptions?.length !== packagingTotalCount) ? _getPackaging : undefined}
                                                            handleSearch={(e) => handleChangeInputForPackaging(1, e?.target?.value)}
                                                            searchValue={searchPackaging}
                                                        />
                                                        <ErrorMessage text={(data?.category?.name === "Packaging Material" && (!data?.packagingName || !data?.packagingName?.itemName?.trim())) ? errors?.packagingName : ""} />
                                                    </Grid>
                                                }
                                                {data?.category?.name === "Other" &&
                                                    <Grid item xs={12} sm={6} lg={4}>
                                                        <CommonAutoComplete
                                                            label="Other Name"
                                                            placeholder="Select Other Name"
                                                            options={otherNameOptions || []}
                                                            getOptionLabel={(option) => option?.itemName || ""}
                                                            value={data?.otherName || null}
                                                            onChange={(e, newValue) => handleChange("otherName", newValue)}
                                                            loadData={(otherNameOptions?.length !== otherNameTotalCount) ? _getOtherName : undefined}
                                                            handleSearch={(e) => handleChangeInputForOtherName(1, e?.target?.value)}
                                                            searchValue={searchOtherName}
                                                        />
                                                        <ErrorMessage text={(data?.category?.name === "Other" && (!data?.otherName || !data?.otherName?.itemName?.trim())) ? errors?.otherName : ""} />
                                                    </Grid>
                                                }
                                                <Grid item xs={12} display={'flex'} justifyContent={'end'} flexWrap={'wrap'} gap={1}>
                                                    <Button className={classes.cancelButton} sx={{ maxWidth: '200px' }} onClick={() => resetFilter()}>Reset Filter</Button>
                                                    <Button className={classes.saveButton} sx={{ maxWidth: '200px' }} onClick={() => { setIsAppliedFilter(true) }}>Applied Filter</Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid item sm={7} md={8} lg={9} >
                                        <CommonAutoComplete
                                            valid
                                            label="All Items"
                                            placeholder="Select Item"
                                            options={allItemsOptions || []}
                                            getOptionLabel={(option) => option?.itemName || ""}
                                            value={data?.allItems || null}
                                            onChange={(e, newValue) => handleChange("allItems", newValue)}
                                            loadData={(allItemsOptions?.length !== allItemsTotalCount) ? _getAllItems : undefined}
                                            handleSearch={(e) => handleChangeInputForAllItems(1, e?.target?.value)}
                                            searchValue={searchAllItems}
                                        />
                                    </Grid>
                                    <Grid item sm={5} md={4} lg={3} alignSelf={"end"} >
                                        <Button variant='outlined' onClick={() => createPurchaseOrder()} sx={{ borderRadius: "10px", backgroundColor: "#FFF", padding: "7px 1rem", "&:hover": { backgroundColor: "#FFF" }, }} startIcon={<AddCircleIcon />}>Add items</Button>
                                    </Grid>
                                    <Grid item xs={12} width={"100px"}>
                                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <StyledTableRow isBordered isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                            <StyledTableCell>{"Item(s)"}</StyledTableCell>
                                                            <StyledTableCell>{"Secondary Name"}</StyledTableCell>
                                                            <StyledTableCell>{"Quantity"}</StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                    {"Unit"}
                                                                    <CommonAutoComplete
                                                                        placeholder="Select Unit"
                                                                        width={"100px"}
                                                                        clearIcon={false}
                                                                        options={unitOptions || []}
                                                                        getOptionLabel={(option) => option?.unit || ""}
                                                                        value={tableOptions?.unit || null}
                                                                        onChange={(e, newValue) => {
                                                                            setTableOptions({ ...tableOptions, unit: newValue });
                                                                            const unitValue = newValue?.unit || null;
                                                                            const updatedItems = purchaseOrderListData.map((ele) => {
                                                                                let inton = ele?.inton || "";
                                                                                if (unitValue?.toLowerCase() === "kg" && (data?.category?.name === "Film" || data?.category?.name === "Base Paper")) {
                                                                                    inton = ele?.quantity / 1000;
                                                                                } else {
                                                                                    inton = "";
                                                                                }
                                                                                return {
                                                                                    ...ele,
                                                                                    unit: unitValue,
                                                                                    inton: inton,
                                                                                };
                                                                            });
                                                                            setPurchaseOrderListData(updatedItems);
                                                                        }}
                                                                        loadData={(unitOptions?.length !== unitTotalCount) ? _getUnit : undefined}
                                                                        handleSearch={(e) => handleChangeInputForUnit(1, e?.target?.value)}
                                                                        searchValue={searchUnit}
                                                                        optionsMargin={0.8}
                                                                        sx={{
                                                                            "& .MuiOutlinedInput-root": { py: "4px !important", borderRadius: "30px", paddingRight: "25px !important", backgroundColor: "#FFF" },
                                                                            "& .MuiAutocomplete-endAdornment": { right: "0px !important" },
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                    {"Rate per Unit"}
                                                                    <CommonAutoComplete
                                                                        width={"60px"}
                                                                        clearIcon={false}
                                                                        placeholder="Select Currency"
                                                                        options={currencyOptions || []}
                                                                        getOptionLabel={(option) => option?.name || ""}
                                                                        value={tableOptions?.currency || null}
                                                                        onChange={(e, newValue) => setTableOptions({ ...tableOptions, currency: newValue })}
                                                                        optionsMargin={0.8}
                                                                        sx={{
                                                                            "& .MuiOutlinedInput-root": { py: "4px !important", borderRadius: "30px" },
                                                                            "& .MuiAutocomplete-endAdornment": { right: "0px !important" }
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </StyledTableCell>
                                                            {(data?.category?.name == "Film" || data?.category?.name == "Base Paper") &&
                                                                <StyledTableCell>{"in Ton"}</StyledTableCell>
                                                            }
                                                            <StyledTableCell>{"Total Amount"}</StyledTableCell>

                                                            <StyledTableCell>{"Delete"}</StyledTableCell>
                                                        </StyledTableRow>
                                                    </TableHead>
                                                    <TableBody isBordered>
                                                        {purchaseOrderListData?.length > 0 ?
                                                            <>
                                                                {purchaseOrderListData?.map((row, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <StyledTableRow isBordered>
                                                                            <StyledTableCell isBordered>
                                                                                <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "300px" }}>
                                                                                    {row?.itemName}
                                                                                </Box>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell isBordered align='center'>
                                                                                {/* <CommonTextField
                                                                                    width={"80px"}
                                                                                    type="text"
                                                                                    name="secondaryName"
                                                                                    value={row?.secondaryName}
                                                                                    placeholder="Enter Secondary Name"
                                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                    onChange={(e) => handleChangeForItems(row, e.target.value, "secondaryName")}
                                                                                /> */}
                                                                                <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", }}>
                                                                                    {row?.secondaryName}
                                                                                </Box>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell isBordered align='center'>
                                                                                <CommonTextField
                                                                                    width={"80px"}
                                                                                    type="number"
                                                                                    name="quantity"
                                                                                    value={row?.quantity}
                                                                                    placeholder="Ex. 10"
                                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                    onChange={(e) => {
                                                                                        if (+e?.target?.value >= 0) {
                                                                                            handleChangeForItems(row, e.target.value, "quantity")
                                                                                        } else {
                                                                                            return;
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </StyledTableCell>
                                                                            {/* <StyledTableCell isBordered >
                                                                                <Box display={'flex'} justifyContent={"center"}>
                                                                                    {row?.unit?.unit ? (
                                                                                        <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "30px", minHeight: "25px" }}>
                                                                                            {row?.unit?.unit}
                                                                                        </Box>
                                                                                    ) : (
                                                                                        <Box sx={{ border: "1px solid #CCCCCC", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "30px", minHeight: "25px", color: "#999999" }}>
                                                                                            -
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            </StyledTableCell> */}
                                                                            <StyledTableCell isBordered align='center' >
                                                                                <Box display={'flex'} justifyContent={"center"}>
                                                                                    {row?.unit ? (
                                                                                        <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "30px", minHeight: "25px" }}>
                                                                                            {row?.unit}
                                                                                        </Box>
                                                                                    ) : (
                                                                                        <Box sx={{ border: "1px solid #CCCCCC", borderRadius: "6px", padding: "6px 10px", width: "fit-content", minWidth: "30px", minHeight: "25px", color: "#999999" }}>
                                                                                            -
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell isBordered align='center'>

                                                                                <CommonTextField
                                                                                    width={"80px"}
                                                                                    type="number"
                                                                                    name="ratePerUnit"
                                                                                    value={row?.ratePerUnit}
                                                                                    placeholder="Ex. 10"
                                                                                    isCurrency
                                                                                    currencyValue={tableOptions?.currency?.symbol}
                                                                                    onChange={(e) => {
                                                                                        if (+e?.target?.value >= 0) {
                                                                                            handleChangeForItems(row, e.target.value, "ratePerUnit")
                                                                                        } else {
                                                                                            return;
                                                                                        }
                                                                                    }}
                                                                                    sx={{
                                                                                        "&.MuiFormControl-root": {
                                                                                            width: "fit-content",
                                                                                            backgroundColor: "#FFF"
                                                                                        },
                                                                                        "& .mui-135eaf6-MuiInputBase-root-MuiOutlinedInput-root": {
                                                                                            paddingLeft: "6px",
                                                                                        },
                                                                                        "& .MuiOutlinedInput-input": {
                                                                                            padding: "10px 5px"
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </StyledTableCell>
                                                                            {(data?.category?.name == "Film" || data?.category?.name == "Base Paper") &&
                                                                                <StyledTableCell isBordered align='center' >
                                                                                    <CommonTextField
                                                                                        width={"80px"}
                                                                                        type="number"
                                                                                        name="inton"
                                                                                        value={row?.inton}
                                                                                        placeholder="Ex. 10"
                                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                                        onChange={(e) => {
                                                                                            if (+e?.target?.value >= 0) {
                                                                                                handleChangeForItems(row, e.target.value, "inton")
                                                                                            } else {
                                                                                                return;
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </StyledTableCell>
                                                                            }
                                                                            <StyledTableCell isBordered align='center' >
                                                                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                    <Box sx={{ bgcolor: theme.palette.lightPrimary.main, color: theme.palette.primary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                                        <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>
                                                                                            {tableOptions?.currency?.symbol}
                                                                                            {(row?.quantity * row?.ratePerUnit || 0) % 1 === 0
                                                                                                ? row?.quantity * row?.ratePerUnit || 0
                                                                                                : (row?.quantity * row?.ratePerUnit || 0).toFixed(2)}</Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            </StyledTableCell>

                                                                            <StyledTableCell isBordered align='center' >
                                                                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                    <IconBackground icon={"delete"}
                                                                                        onClick={(e) => {
                                                                                            confirmDialogue({
                                                                                                title: `Are you sure you want to delete?`,
                                                                                            }).then(() => {
                                                                                                handleDeleteItem(row)
                                                                                            }).catch((err) => { console.error(err) });
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    </React.Fragment>
                                                                ))}
                                                                <StyledTableRow isBordered sx={{ backgroundColor: "transparent !important", borderTop: "1px solid #0000001a" }}>
                                                                    <StyledTableCell isBordered colSpan={6}  ></StyledTableCell>
                                                                    <StyledTableCell isBordered sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Box sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.lightPrimary.main, textAlign: "center", width: "fit-content", minWidth: "80px", padding: "11px 10px", borderRadius: "10px" }}>
                                                                            <Typography fontSize={"12px"} fontFamily={"Satoshi-Bold"}>
                                                                                {tableOptions?.currency?.symbol}
                                                                                {(() => {
                                                                                    const total = purchaseOrderListData.reduce(
                                                                                        (acc, row) => acc + (row?.quantity * row?.ratePerUnit || 0),
                                                                                        0
                                                                                    );
                                                                                    return total % 1 === 0 ? total : total.toFixed(2);
                                                                                })()}
                                                                            </Typography>
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell isBordered></StyledTableCell>
                                                                </StyledTableRow>
                                                            </>
                                                            :
                                                            <StyledTableRow>
                                                                <StyledTableCell colSpan={12}>
                                                                    <NoDataFound />
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Grid>
                                    {(data?.category?.name === "Base Paper" || data?.category?.name === "Film") &&
                                        <Grid container item xs={12} >
                                            <Grid item xs={12} sm={6} lg={3}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position">
                                                        <FormControlLabel
                                                            value="end"
                                                            control={<Checkbox checked={data?.isRuninngMeter} onChange={(e) => handleChange("isRuninngMeter", e.target.checked)} />}
                                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                            label={"Running Meter"}
                                                            labelPlacement="end"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                            {data?.isRuninngMeter &&
                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                    <CommonTextField
                                                        type="text"
                                                        name="runningMeter"
                                                        value={data?.runningMeter}
                                                        placeholder="Enter The Running meter"
                                                        onChange={(e) => handleChange("runningMeter", e.target.value)}
                                                    />
                                                    <ErrorMessage text={(data?.isRuninngMeter && !data?.runningMeter?.trim()) ? errors.runningMeter : ""} />
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                    {(data?.category?.name === "Base Paper" || data?.category?.name === "Film") &&
                                        <Grid container item xs={12}>
                                            <Grid item xs={12} sm={6} lg={3}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position">
                                                        <FormControlLabel
                                                            value="end"
                                                            control={<Checkbox checked={data?.isCore} onChange={(e) => handleChange("isCore", e.target.checked)} />}
                                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                            label={"Core Id"}
                                                            labelPlacement="end"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                            {data?.isCore &&
                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                    <CommonTextField
                                                        type="text"
                                                        name="core"
                                                        value={data?.core}
                                                        placeholder="Enter The Core"
                                                        onChange={(e) => handleChange("core", e.target.value)}
                                                    />
                                                    <ErrorMessage text={(data?.isCore && !data?.core?.trim()) ? errors.core : ""} />
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                    {data?.vendorType?.id == 2 &&
                                        <Grid container item xs={12}>
                                            <Grid item xs={12} sm={6} lg={3}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position">
                                                        <FormControlLabel
                                                            value="end"
                                                            control={<Checkbox checked={data?.isPort} onChange={(e) => handleChange("isPort", e.target.checked)} />}
                                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                            label={"Port"}
                                                            labelPlacement="end"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                            {data?.isPort &&
                                                data?.vendorType?.id == 2 &&
                                                <>
                                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                                        <CommonAutoComplete
                                                            // label="Port"
                                                            // valid
                                                            placeholder="Select Port"
                                                            options={portOptions || []}
                                                            getOptionLabel={(option) => option?.label || ""}
                                                            value={data?.port || null}
                                                            onChange={(e, newValue) => handleChange("port", newValue)}
                                                        />
                                                        <ErrorMessage text={(data?.isPort && !data?.port?.label) ? errors.port : ""} />
                                                    </Grid>
                                                    {data?.port &&
                                                        <Grid item xs={12} sm={6} md={4} lg={3} ml={2} alignSelf={'end'}>
                                                            <CommonRadioButton
                                                                radioLabels={portAnotherOptions}
                                                                name="status"
                                                                selectedValue={data?.status}
                                                                handleChange={(e) =>
                                                                    handleChange("status", e.target.value)
                                                                }
                                                            /><br />
                                                            <ErrorMessage text={(data?.isPort && data?.port?.label && !data?.status) ? errors.status : ""} />
                                                        </Grid>
                                                    }
                                                </>
                                            }
                                        </Grid>
                                    }
                                    {data?.vendorType?.id == 2 &&
                                        <Grid container item xs={12} spacing={2}>
                                            <Grid item xs={12} sm={6} lg={3}>
                                                <FormControl component="fieldset">
                                                    <FormGroup aria-label="position">
                                                        <FormControlLabel
                                                            value="end"
                                                            control={<Checkbox checked={data?.isProductionMonth} onChange={(e) => handleChange("isProductionMonth", e.target.checked)} />}
                                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                            label={"Production Month"}
                                                            labelPlacement="end"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                            {data?.isProductionMonth &&
                                                <>
                                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                                        <CommonAutoComplete
                                                            placeholder="Select Production Month"
                                                            options={monthsOption || []}
                                                            getOptionLabel={(option) => option?.name || ""}
                                                            value={data?.productionMonth || null}
                                                            onChange={(e, newValue) => handleChange("productionMonth", newValue)}
                                                        />
                                                        <ErrorMessage text={(data?.isProductionMonth && (!data?.productionMonth || !data?.productionMonth?.name)) ? errors?.productionMonth : ""} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                                        <CommonAutoComplete
                                                            valid
                                                            placeholder="Select Production Year"
                                                            options={yearOptionsForProduction || []}
                                                            getOptionLabel={(option) => option?.name || ""}
                                                            value={data?.productionYear || null}
                                                            onChange={(e, newValue) => handleChange("productionYear", newValue)}
                                                        />
                                                        <ErrorMessage text={(data?.isProductionMonth && (!data?.productionYear?.name)) ? errors?.productionYear : ""} />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    }
                                    {/* <Grid item xs={12} >
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"16px"} mb={1.5}>Terms and Conditions</Typography>
                                        <ul style={{ fontSize: "14px", fontFamily: "Satoshi-Light", paddingLeft: "20px", color: "#2E2E30", margin: "5px 0px 0px 0px", lineHeight: "22px" }}>
                                            <li>Quantity Tolerance + 20%.</li>
                                            <li>Test Certificate Require (COA).</li>
                                            <li>Mention Our P.O. No. & Date on All Documents.</li>
                                        </ul>
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"16px"} mb={1.5}>
                                            Terms and Conditions
                                        </Typography>
                                        <FormGroup sx={{ fontSize: "14px", fontFamily: "Satoshi-Light", color: "#2E2E30", lineHeight: "22px" }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value={1}
                                                        checked={data?.selectedCondition?.includes(1)}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                }
                                                label="Quantity Tolerance + 20%."
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value={2}
                                                        checked={data?.selectedCondition?.includes(2)}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                }
                                                label="Test Certificate Require (COA)."
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value={3}
                                                        checked={data?.selectedCondition?.includes(3)}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                }
                                                label="Mention Our P.O. No. & Date on All Documents."
                                            />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl component="fieldset">
                                            <FormGroup aria-label="position">
                                                <FormControlLabel
                                                    value="end"
                                                    control={<Checkbox checked={data?.isAdditionalTermsAndCondition} onChange={(e) => handleChange("isAdditionalTermsAndCondition", e.target.checked)} />}
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={"Add Additional Terms And Condition"}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    {data?.isAdditionalTermsAndCondition &&
                                        <Grid item xs={12} >
                                            <Typography
                                                variant="body1"
                                                sx={{ mb: 1, color: "text.primary" }}
                                            >
                                                Additional Terms and Conditions
                                            </Typography>
                                            <CommonTextEditor
                                                valid
                                                label="Select a bullet point or number and add an additional note."
                                                value={data?.additionalTermsAndConditions}
                                                onChange={(e) => handleChange("additionalTermsAndConditions", e)}
                                            />
                                            <ErrorMessage text={(data?.isAdditionalTermsAndCondition && (!data?.additionalTermsAndConditions || data?.additionalTermsAndConditions == "<p><br></p>")) ? errors?.additionalTermsAndConditions : ""} />
                                        </Grid>
                                    }
                                    {/* <Grid item xs={12} >
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"16px"} mb={1.5}>Payment Condition</Typography>
                                        <Typography fontFamily={"Satoshi-Light"} fontSize={"14px"} color={"#2E2E30"}>If the goods are found defective or non-compliant, the buyer may request a replacement, refund, or reject the order.</Typography>
                                        <ul style={{ fontSize: "14px", fontFamily: "Satoshi-Light", paddingLeft: "20px", color: "#2E2E30", margin: "5px 0px 0px 0px", lineHeight: "22px" }}>
                                            <li>Prices are as agreed upon in the PO and are fixed unless otherwise stated.</li>
                                            <li>Payment terms: [e.g., Net 30 days from invoice date]</li>
                                        </ul>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl component="fieldset">
                                            <FormGroup aria-label="position">
                                                <FormControlLabel
                                                    value="end"
                                                    control={<Checkbox checked={data?.isAdditionalPaymentCondition} onChange={(e) => handleChange("isAdditionalPaymentCondition", e.target.checked)} />}
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={"Add Additional Payment Condition"}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    {data?.isAdditionalPaymentCondition &&
                                        <Grid item xs={12} >
                                            <CommonTextEditor
                                                valid
                                                label="Additional Payment Condition"
                                                value={data?.additionalPaymentCondition}
                                                onChange={(e) => handleChange("additionalPaymentCondition", e)}
                                            />
                                            <ErrorMessage text={(data?.isAdditionalPaymentCondition && (!data?.additionalPaymentCondition || data?.additionalPaymentCondition == "<p><br></p>")) ? errors?.additionalPaymentCondition : ""} />
                                        </Grid>
                                    } */}
                                </Grid>
                                :
                                <Grid container spacing={2}>
                                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} >
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>Preview Purchase Order (PO)</Typography>
                                        <Button
                                            className={classes?.downloadButton}
                                            onClick={() => _downloadPO()}
                                            startIcon={<Assets absolutePath={true} src={`/assets/img/Download.svg`} />}
                                        >
                                            Download
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} display={"flex"} justifyContent={"center"} >
                                        {base64 &&
                                            <iframe src={`data:text/html;base64,${base64}`}
                                                width="100%"
                                                height="1000"
                                                frameBorder="0"
                                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                style={{ borderRadius: '10px' }}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                        }
                    </Box>
                </Grid >
                <Grid item xs={12} display={"flex"} justifyContent={"end"} gap={2}>
                    {activeStep != 0 &&
                        <Button className={classes.cancelButton} onClick={handleBack} disabled={activeStep === 0}>{activeStep === 0 ? "Cancel" : "Previous"}</Button>
                    }
                    <Button className={classes.saveButton} onClick={handleNext} >{activeStep === steps.length - 1 ? "Close" : "Next"}</Button>
                </Grid>
            </Grid >
        </Box >
    );
};

export default AddUpdatePo;
